import React from "react";
import StepShell from "./StepShell";
import { DoneCheck } from "./Confirmation";

export default function Terminal({ status }) {
  let title = "This link is no longer active";
  let body = "Reach out to your dispatcher.";
  if (status === "booked") {
    return (
      <Notice
        title="You're booked on this load"
        body="Check your texts for the rate confirmation."
        hero={<DoneCheck />}
      />
    );
  }
  if (status === "failed") {
    title = "We couldn't get this one";
    body = "We'll keep watching and send another match.";
  } else if (status === "expired") {
    title = "This link has expired";
    body = "Reach out to your dispatcher if you still want this load.";
  }
  return <Notice title={title} body={body} />;
}

export function Notice({ title, body, hero, onDecline }) {
  return (
    <StepShell question={title} hero={hero} onDecline={onDecline}>
      {body && (
        <p className="m-0 font-[Roboto] text-[17px] leading-snug text-slate-600">
          {body}
        </p>
      )}
    </StepShell>
  );
}
